import FullPageLoader from './full-page-loader';
import ContainerLoader from './container-loader';

export { FullPageLoader, ContainerLoader };
export default { FullPageLoader, ContainerLoader };
